module.exports = __webpack_public_path__ + "media/src/components/shared/general/img/otbLogo-787ae19d81aa504964fe941d54e31c43.png";